export default __webpack_public_path__ + "/images/sign-in-with-twitter-gray.png.img.fullhd.medium.png";